// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import checkoutSharedStyles from "@turnerBlueprint/App/SharedStyles/CheckoutStyles";
import { onePageCheckoutPaymentDetailsStyles } from "@turnerBlueprint/Overrides/Widgets/OnePageCheckout/OnePageCheckoutPaymentDetails";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { mergeWithCss } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

onePageCheckoutPaymentDetailsStyles.paymentDetailsGridContainer = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

onePageCheckoutPaymentDetailsStyles.paymentDetailsHeadingText = {
    variant: "h3",
    css: css`
        margin-bottom: 12px;
    `,
};

onePageCheckoutPaymentDetailsStyles.fieldset = {
    ...mergeWithCss(checkoutSharedStyles.container, {
        css: css`
            margin: 0;
            padding: 0;
            border: 0;
        `,
    }),
};

onePageCheckoutPaymentDetailsStyles.saveCardCheckboxGridItem = {
    css: css`
        margin-top: 16px;
    `,
};

onePageCheckoutPaymentDetailsStyles.paymentProfileEditCardLink = {
    typographyProps: {
        size: 12,
        lineHeight: "14px",
    },
    css: css`
        white-space: nowrap;
        margin-left: 12px;
    `,
};

onePageCheckoutPaymentDetailsStyles.paymentProfileBillingAddress = {
    label: {
        variant: "h6",
        css: css`
            margin-bottom: 8px;
        `,
    },
    text: {
        variant: "h6",
        weight: fontConfig.weight.regular,
    },
};

onePageCheckoutPaymentDetailsStyles.savedPaymentProfileWrapper = {
    css: css`
        margin-top: 12px;
        max-width: 91px;
    `,
};

onePageCheckoutPaymentDetailsStyles.paymentProfileExpiredErrorWrapper = {
    css: css`
        margin-top: 12px;
        display: flex;
        width: 100%;
    `,
};
